import React from 'react';
import AWingBlank from 'antd-mobile/lib/wing-blank';



export default class WingBlank extends AWingBlank {}